import React, { useState } from "react";
import { APPLICATION_REJECTION_REASONS } from "./StatusControl/configs/applicationConfig";
import FormPopover from "./FormPopover";

interface RejectionPopoverProps {
  show: boolean;
  onClose: () => void;
  onReject: (reason: string, note?: string) => void;
  isLoading: boolean;
  align?: "left" | "right";
}

const RejectionPopover: React.FC<RejectionPopoverProps> = ({
  show,
  onClose,
  onReject,
  isLoading,
  align = "left",
}) => {
  const [rejectionReason, setRejectionReason] = useState("");
  const [rejectionNote, setRejectionNote] = useState("");

  const handleClose = () => {
    setRejectionReason("");
    setRejectionNote("");
    onClose();
  };

  const handleReject = () => {
    if (!rejectionReason) return;
    onReject(rejectionReason, rejectionNote || undefined);
    setRejectionReason("");
    setRejectionNote("");
  };

  return (
    <FormPopover
      show={show}
      onClose={handleClose}
      title="Rejection Reason"
      align={align}
      submitLabel="Reject"
      submitLoadingLabel="Rejecting..."
      submitColor="#ef4444"
      canSubmit={!!rejectionReason}
      isLoading={isLoading}
      onSubmit={handleReject}
    >
      <select
        value={rejectionReason}
        onChange={(e) => setRejectionReason(e.target.value)}
        style={{
          width: "100%",
          padding: "6px 8px",
          borderRadius: "4px",
          border: "1px solid #d1d5db",
          fontSize: "12px",
          marginBottom: "8px",
        }}
      >
        <option value="">Select reason...</option>
        {Object.entries(APPLICATION_REJECTION_REASONS).map(([key, config]) => (
          <option key={key} value={key}>
            {config.label}
          </option>
        ))}
      </select>
      <textarea
        value={rejectionNote}
        onChange={(e) => setRejectionNote(e.target.value)}
        placeholder="Additional notes (optional)"
        rows={2}
        style={{
          width: "100%",
          padding: "6px 8px",
          borderRadius: "4px",
          border: "1px solid #d1d5db",
          fontSize: "12px",
          marginBottom: "8px",
          resize: "vertical",
        }}
      />
    </FormPopover>
  );
};

export default RejectionPopover;
